module.exports = __webpack_public_path__ + "mobile/img/hot-img3.0d551922.png";